<app-modal
  #modal
  [modalConfig]="modalConfig"
  (isDismissing)="reset()"
  (isClosing)="reset()">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.dismiss()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="newFolderName" class="form-label">Folder Name</label>
          <input
            id="newFolderName"
            type="text"
            class="form-control"
            [(ngModel)]="folderName"
            placeholder="Enter folder name"
            (keyup.enter)="save()" />
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-between" footerContent>
    <button type="button" class="btn btn-reset" (click)="modal.dismiss()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!folderName.trim() || saving"
      (click)="save()">
      <span
        *ngIf="saving"
        class="spinner-border spinner-border-sm me-1"
        role="status"
        aria-hidden="true"></span>
      {{ saving ? "Creating..." : "Create Folder" }}
    </button>
  </div>
</app-modal>
